
import domready from '../utils/domready.js';
  domready(function() {
    document.addEventListener('click', function(event) {
      if (event.target.id === 'to-accommodation-programs') {
        var container = document.getElementById('accommodation-programs');
        if (container) {
          var openedContainerTop = container.getBoundingClientRect().top;
          if (openedContainerTop < 48) { // 48 eqs 3rem of top-bar
            var scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, scrollPosition + openedContainerTop - 48); // should be $container.scrollIntoView();, but well… iOS
          }
        }
        event.target.blur();
      }
    });
  });
